<template>
  <zt-dialog
    class="dialog"
    :title="`选择抓取${typeCn}`"
    :visible.sync="visibleInside"
    :append-to-body="true"
    :modal-append-to-body="false"
    ref="dialog"
    @opened="opened"
    :modal="modal"
  >
    <!-- 瀑布流 -->
    <el-scrollbar style="height: 100%">
      <waterfall class="waterfall" :line-gap="192" :min-line-gap="20" :watch="imgsArr">
        <waterfall-slot
          v-for="(item, index) in imgsArr"
          :width="item.width"
          :height="item.height"
          :order="index"
          :key="item.id"
        >
          <div class="waterfall-item" @click="selected(item)">
            <outline :show="item.selected"></outline>
            <div>
              <img :src="item.src" alt />
            </div>
          </div>
        </waterfall-slot>
      </waterfall>
    </el-scrollbar>
    <div slot="footer" class="dialog-footer">
      <span class="couter">已选择{{this.selectedArr.length}}张</span>
      <zt-button @click="changeVisible(false)" class="mr10">取 消</zt-button>
      <zt-button type="primary" @click="confirm">确 定</zt-button>
    </div>
  </zt-dialog>
</template>

<script>
import Waterfall from 'vue-waterfall/lib/waterfall';
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot';

import ZtDialog from '@cps/ZtDialog';
import outline from './outline';

export default {
  components: {
    Waterfall,
    WaterfallSlot,

    ZtDialog,
    outline,
  },

  props: {
    // 可见
    visible: {
      type: Boolean,
      default: false,
    },
    // 可选图片
    optionalPic: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      // 类型: image / video
      type: String,
      default: 'image',
    },

    // 蒙版
    modal: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    typeCn() {
      return this.type === 'image' ? '图片' : '视频';
    },
  },

  data: () => ({
    couter: 0, // 计数器,
    visibleInside: false,
    imgsArr: [],
    selectedArr: [],
    show: false,
  }),

  watch: {
    visible() {
      this.visibleInside = this.visible;
    },
    visibleInside() {
      this.$emit('update:visible', this.visibleInside);
    },
  },

  methods: {
    // dialog 打开
    opened() {
      this.getImgsArr();
    },

    selected(item) {
      if (item.selected) {
        item.selected = false;
      } else {
        item.selected = true;
      }
      this.filter();
    },

    filter() {
      this.selectedArr = this.imgsArr.filter((v) => {
        return v.selected === true;
      });
    },

    // 确定
    confirm() {
      this.filter();
      this.$emit('change', this.selectedArr);
      this.changeVisible(false);
    },

    // 改变 - 可见
    changeVisible(boole) {
      this.visibleInside = boole;
    },

    // 获取图片
    async getImgsArr() {
      if (!this.optionalPic.length) return;
      var imgsArr = [];
      var loadArr = [];
      // var bodyWidth = this.$refs.dialog.$el.querySelector('.el-dialog__body').clientWidth - 40;
      this.optionalPic.forEach((v) => {
        loadArr.push(this.picLoad(v));
      });
      await Promise.all(loadArr)
        .then((result) => {
          result.forEach((v) => {
            var width = v.img.width;
            var height = v.img.height;
            imgsArr.push({
              width,
              height,
              src: v.v.src,
              selected: false,
              id: v.v.id,
            });
          });
        })
        .catch((result) => {
          console.log(result);
        });
      this.imgsArr = imgsArr;
    },

    // 图片拉取
    picLoad(v) {
      return new Promise(function(resolve, reject) {
        var img = new Image();
        img.src = v.src;
        if (img.complete) {
          resolve({
            v,
            img,
          });
        }
        img.onload = function() {
          resolve({
            v,
            img,
          });
        };
        img.onerror = function() {
          reject(v, img);
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog /deep/ .el-dialog__body {
  height: 400px;
}

.el-scrollbar /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.waterfall /deep/ .vue-waterfall-slot {
  padding: 6px;

  .waterfall-item {
    position: relative;
    border: 1px solid $theme-textplaceholder;
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }
}
.couter {
  float: left;
  font-size: 12px;
  color: $theme-textsecond;
}
</style>